// extracted by mini-css-extract-plugin
export default {"products":"Ss-z","card":"Ts-z","oosMessaging":"Us-z"};